module.exports = __webpack_public_path__ + "img/home_b.e0a503d1.svg";